<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const getClass = () => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  Object.keys(props.item.terms).forEach((taxonomy) => {
    props.item.terms[taxonomy].forEach((term) => {
      className += ` tease-${taxonomy}-${term.slug}`;
    });
  });
  className += " tease-nr-" + props.nr;
  return className;
};

</script>

<template>
  <article :class="getClass()" :id="'tease-' + item.id" v-html="item.html"></article>
</template>
